import { PersonItem } from '../Card';
import React from 'react';

import { PersonItemsFragment } from '../../generated/graphql';
import { resizeImageW } from '../../helpers/mediaApiUrls';
import { personItemRoute } from '../../helpers/routes';
import { PageItemLink } from '../PageItemLink';
import { ItemProps } from './common';

const Person: React.FC<ItemProps> = ({ item, page, dragProps, className, preview }) => {
  const person = item as PersonItemsFragment;
  let photoPath = resizeImageW(person.photo?.mediaUrl, 40);

  return (
    <PageItemLink
      to={personItemRoute(page.id, person.id, preview)}
      page={page}
      pageItem={item}
      data-testid={`person-item-${person.id}`}
    >
      <PersonItem
        id={person.id}
        name={person.name}
        role={person.role}
        photoPath={photoPath}
        className={className}
        {...dragProps}
      />
    </PageItemLink>
  );
};

export default Person;
